import React , {forwardRef} from "react";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../datatable/DataTable.css";
import { themeQuartz } from "ag-grid-community";



import { provideGlobalGridOptions } from 'ag-grid-community';

provideGlobalGridOptions({
    theme: "legacy",
    spacing: 4
})



const GraphTable = ({ height, columns, rows, paginationProp, paginationPageSize, onPaginationChanged, paginationPageSizeSelector, rowSelection, isRowSelectable, suppressRowClickSelection, onRowSelected, gridOptions, onGridReady, onSelectionChanged, headerCheckboxSelectionFilterOnly, isCellCheckboxSelection, onFirstDataRendered, ref, selectionColumnDef, getRowStyle, getRowId, cellEditorParams, stopEditingWhenCellsLoseFocus, onCellValueChanged, onFilterChanged, postFilterChanged, suppressMenuHide, getRowHeight, defaultColDef }) => {

    return (
        <div
            className="ag-theme-quartz"
            style={{ height: height || 600, width: 'auto' }}
        >
            <AgGridReact
                spacing={4} 
                ref={ref}
                rowData={rows}
                columnDefs={columns}
                pagination={paginationProp || true}
                // rowModelType={"serverSide"}
                paginationPageSize={paginationPageSize || 10}
                onPaginationChanged={onPaginationChanged}
                paginationPageSizeSelector={paginationPageSizeSelector || [10, 20, 30, 50, 100]}
                rowSelection={rowSelection || "multiple"}
                isRowSelectable={isRowSelectable}
                suppressRowClickSelection={suppressRowClickSelection || true}
                //getRowClass={(param)=>'ag-row-hover'}
                moveColumns={false}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={false}
                onRowSelected={onRowSelected}
                gridOptions={gridOptions}
                onGridReady={onGridReady}
                onSelectionChanged={onSelectionChanged}
                headerCheckboxSelectionFilterOnly={headerCheckboxSelectionFilterOnly}
                isCellCheckboxSelection={isCellCheckboxSelection}
                onFirstDataRendered={onFirstDataRendered}
                selectionColumnDef={selectionColumnDef}
                getRowStyle={getRowStyle}
                getRowId={getRowId}
                cellEditorParams={cellEditorParams}
                stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus || true}
                onCellValueChanged={onCellValueChanged}
                onFilterChanged={onFilterChanged}
                postFilterChanged={postFilterChanged}
                suppressMenuHide={suppressMenuHide}
                // enableCellTextSelection={true} 
                getRowHeight={getRowHeight}
                suppressRowTransform={true}
                defaultColDef={defaultColDef}
                enableRangeSelection={true} // Enable range selection
                enableFillHandle={true} // Enable drag fill/copy
                rowGroupPanelShow="never" // Show row group panel
                pivotPanelShow="always" // Show pivot panel
                enableCharts={true} // Enable charting features
                groupDisplayType="groupRows"
            />
        </div>
    )
}
export default GraphTable